import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import AcompanhamentoEntregaMateriaPrima from "../../components/classes/AcompanhamentoEntregaMateriaPrima";
import AcompanhamentoEntregaMateriaPrimaDataset from "../../components/data/AcompanhamentoEntregaMateriaPrimaDataset";
import SkuHelper from "../../helper/skuHelper";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function AcompanhamentoCargaGridMateriaPrima() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);
  const [
    acompanhamentoEntregaMateriaPrimaArr,
    setAcompanhamentoEntregaMateriaPrimaArr,
  ] = useState<AcompanhamentoEntregaMateriaPrima[]>([]);
  const [rows, setRows] = useState<Data>([]);
  const [selectedRow, setSelectedRow] = useState<any>();

  const columns: GridColumns = createColumns();

  const acompanhamentoEntregaMateriaPrimaDataset: AcompanhamentoEntregaMateriaPrimaDataset =
    new AcompanhamentoEntregaMateriaPrimaDataset();

  useEffect(() => {
    Utils.setDocumentTitle("Acompanhamento Matéria Prima");
    fetchData();
  }, []);

  async function fetchData() {
    acompanhamentoEntregaMateriaPrimaDataset.getAll().then((result) => {
      fillTable(result);
      setAcompanhamentoEntregaMateriaPrimaArr(result);
      setLoading(false);
    });
  }

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "idAcompanhamentoSolicitacaoMateriaPrima",
        headerName: t("common.id"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderHeader: (item) => {
          return <div>#</div>;
        },
      },
      {
        field: "sku",
        headerName: t("common.sku"),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "descricao",
        headerName: t("common.skuDescription.label"),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return <div>{SkuHelper.getSKUName(item.row.sku)}</div>;
        },
      },
      {
        field: "centroOrigem",
        headerName: t("common.originCenter"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "quantidade",
        headerName: t("common.orderQuantity"),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "dataEmbarque",
        headerName: t("common.boardingDate"),
        type: "date",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>{new Date(item.row.dataEmbarque).toLocaleDateString("pt-BR")}</p>
          );
        },
      },
      {
        field: "dataEntrega",
        headerName: t("common.deliveryDate"),
        type: "date",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>{new Date(item.row.dataEntrega).toLocaleDateString("pt-BR")}</p>
          );
        },
      },
      {
        field: "remessa",
        headerName: t("common.shipping"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      // {
      //   field: "ocr",
      //   headerName: "OCR",
      //   type: "string",
      //   width: 180,
      //   editable: false,
      //   align: "center",
      //   headerAlign: "center",
      // },
      {
        field: "nf",
        headerName: t("common.invoice"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "placaCarreta",
        headerName: t("pages.deliveriesRawMaterial.text.truckPlate"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "observacoes",
        headerName: t("common.observations"),
        type: "string",
        width: 180,
        editable: true,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "laudo",
        headerName: t("common.report"),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (gridItem) => {
          return (
            <>
              <input
                type={"file"}
                id={`gridMateriaPrimafileUpload-${gridItem.id}`}
                onChange={(e) => handleAttachLaudoChange(e)}
                hidden
              />
              {!gridItem.row.laudo ||
                (gridItem.row.laudo && !gridItem.row.laudo.name) ? (
                <div>
                  <Tooltip title={t("common.attachReport")}>
                    <IconButton
                      onClick={() => handleAttachLaudoClick(gridItem)}
                    >
                      <AttachFileIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <div>
                  <Tooltip title={t("common.downloadReport")}>
                    <IconButton
                      onClick={() => handleAttachLaudoDownload(gridItem)}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("common.deleteReport")}>
                    <IconButton
                      onClick={() => handleAttachLaudoCancel(gridItem)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              )}
            </>
          );
        },
      },
    ];
    return cols;
  }

  async function fillTable(
    acompanhamentoEntregaMateriaPrimaArr: AcompanhamentoEntregaMateriaPrima[]
  ) {
    let gridData: Data = [];
    let i: number = 0;
    for await (const item of acompanhamentoEntregaMateriaPrimaArr) {
      let json = JSON.parse(AcompanhamentoEntregaMateriaPrima.toJson(item));

      json.id = i;
      if (item.laudo) {
        json.laudo = await urltoFile(
          item.laudo.toString(),
          `laudo_${item.remessa}.pdf`,
          "application/pdf"
        );
      }
      gridData.push(json);
      i++;
    }
    setRows(gridData);
  }

  function handleAttachLaudoClick(gridItem: any): void {
    document
      .getElementById(`gridMateriaPrimafileUpload-${gridItem.id}`)
      ?.click();
    setSelectedRow(gridItem);
  }

  function handleAttachLaudoCancel(gridItem: any): void {
    let el: HTMLInputElement = document.getElementById(
      `gridMateriaPrimafileUpload-${gridItem.id}`
    ) as HTMLInputElement;
    el.value = "";
    setSelectedRow(null);
    let updatedArray = [...rows];
    updatedArray.forEach((item: any, index) => {
      if (item.id == gridItem.id) {
        item.laudo = new Blob();
      }
    });
    setRows(updatedArray);
  }

  function handleAttachLaudoDownload(gridItem: any): void {
    let file = gridItem.row.laudo;
    let fr = new FileReader();
    fr.readAsDataURL(file);

    var blob = new Blob([file], { type: "application/pdf" });

    var objectURL = window.URL.createObjectURL(blob);

    var link = document.createElement("a");
    link.href = objectURL;

    link.download = `laudo_${gridItem.row.remessa}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  function handleAttachLaudoChange(e: ChangeEvent<HTMLInputElement>) {
    if (e.target && e.target.files && e.target.files[0]) {
      let updatedArray = [...rows];
      updatedArray.forEach((item: any, index) => {
        if (item.id == selectedRow.id) {
          item.laudo = e.target.files![0];
        }
      });
      setRows(updatedArray);
    }
  }

  function handleRowEditCommit(params: any) {
    let rowsArr = [...rows];
    rowsArr.forEach((row: any, index: number) => {
      if (row.id == params.id) {
        row[params.field] = params.value;
      }
    });
    setRows(rowsArr);
  }

  async function handleSalvarClick() {
    setLoading(true);
    let rowsArr: any[] = [...rows];
    for await (const item of rowsArr) {
      if (item.laudo instanceof File) {
        item.laudo = await getBase64(item.laudo);
      } else {
        item.laudo = "";
      }
      item.id = item.idAcompanhamentoSolicitacaoMateriaPrima;
    }
    setRows([]);
    acompanhamentoEntregaMateriaPrimaDataset.update(rowsArr).then((success) => {
      setLoading(false);
      if (success == true) {
        fetchData();
      }
    });
  }

  async function getBase64(file: File) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function urltoFile(
    url: string,
    filename: string,
    mimeType: string
  ): Promise<File> {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  return (
    <>
      <div
        className={styles.table}
        style={{
          justifyContent: "end",
          alignItems: "end",
        }}
      >
        <div className="containerToolbar">
          <Tooltip title={t("pages.deliveriesRawMaterial.text.saveAllChanges")}>
            <span>
              <IconButton onClick={handleSalvarClick} disabled={loading}>
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        </div>
        <div
          className={styles.table}
          style={{
            borderRadius: "30px",
          }}
        >
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
            onCellEditCommit={handleRowEditCommit}
          // columnVisibilityModel={{
          //   id: false,
          // }}
          />
        </div>
      </div>
    </>
  );
}
